import React from "react";
import FullpageMessage from "./FullpageMessage";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Link } from "@react-email/link";
import { useAuth } from "@/services/auth/AuthContext";

interface Props {}

const LoginErrorPage: React.FC<Props> = ({}) => {
  const { logout } = useAuth();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("user");

  const { t } = useTranslation();

  const supportEmail = "support@dreamhub.ai";
  const subtitle = (
    <>
      {t("loginErrorPage.subtitle")}
      <Link href={`mailto:${supportEmail}`} target="_blank">
        {supportEmail}
      </Link>
    </>
  );

  return (
    <FullpageMessage
      title={t("loginErrorPage.title")}
      subtitle={subtitle}
      additionalInfo={t("loginErrorPage.loggedInAs", {
        user: userId
      })}
      buttonLabel={t("FullpageMessage.backButton")}
      onButtonClick={() => logout()}
    />
  );
};

export default LoginErrorPage;
